import React, { useState, useEffect, useRef } from "react"
import Flink from '~/components/shared/flink'
import { usePlp } from '~/contexts/PlpContext'
import useSearchHook from '~/utils/use-search'
// import { useTheme } from '~/contexts/ThemeContext'
import useAnalytics from '~/utils/analytics'
import { isStag, jnstyls, compact } from '~/utils/helpers'

import IconSearch from '~/components/icons/search'

import * as styles from "~/styles/plp/plp_bar.module.scss"
import * as sstyles from "~/styles/testing/test_search_panel.module.scss"

const CollSearch = () => {
  // const { analytics, setAnalytics } = useTheme()
  const { 
    collection, products, allProducts, filters, setSearching,
    fuseIndex, setFuseIndex , setSearchVals
  } = usePlp()
  const collGend = collection.gender

  const { getSearchData, setupFuse, buildVals } = useSearchHook()
  const { elev_search } = useAnalytics()

  const [searchData, setSearchData] = useState(null)

  const inptRef = useRef(null)
  const searchTimeout = useRef(null)

  const searchClear = () => {
    setSearching(false)
    inptRef.current.value = ''
  }

  const handleSearch = () => {
    if (!fuseIndex) return
    const val = inptRef.current.value.toLowerCase()
    if ( val === '' ) {
      searchClear()
      return
    }
    if ( val.length < 3 ) return

    const hasSpaces = val.includes(' ')
    let val_arr = buildVals(val, fuseIndex, collGend)

    setSearchVals(val_arr)
    setSearching(val)
  }

  const debounce = (func, delay) => {
    return (...args) => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current)
      }
      searchTimeout.current = setTimeout(() => {
        func(...args)
      }, delay)
    }
  }

  const get_search_data = async () => {
    const data = await getSearchData()
    setSearchData(data)
  }

  const select_coll_prods = (indxProds) => {
    const all_ids = allProducts.map(x => x.mid)
    const coll_search = compact( all_ids.map(id => indxProds.find(x => x.mid === id)))
    setSearchData(coll_search)
  }

  useEffect(() => {
    if (!searchData) get_search_data()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!searchData) return
    if (fuseIndex) return
    setupFuse(searchData, setFuseIndex)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData])

 
  return (
    <div 
      className={styles.csearch} 
    >
      <div className={jnstyls([sstyles.inputwr, styles.inputwr])}>
        <input 
          type="search"
          name="q"
          placeholder="Search collection"
          className={jnstyls([sstyles.search_inpt, styles.search_inpt])}
          onChange={(e)=>{handleSearch()}}
          ref={inptRef}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="none"
          spellCheck="false"
        />
        {inptRef?.current?.value != '' && (
          <button
            type='button'
            className={jnstyls([sstyles.clear, styles.sclear])}
            onClick={(e) => searchClear()}
          >
            Clear
          </button>
        )}
        <div className={jnstyls([sstyles.search_btn, styles.search_btn])}>
          <IconSearch icon_classes={''} />
        </div>
      </div>
    </div>
  )
}



export default CollSearch





